<template>
  <div class="row q-mx-sm">
    <div class="col-12 col-md q-mb-lg text-center">
      <div class="title-block">
        <div class="title-block--header">
          {{ content.transfers_everywhere }}
        </div>
        <div
          class="title-block--body"
          v-html="content.at_the_best_price"
        />
      </div>
    </div>
    <div class="col-12 col-md q-mb-lg text-center">
      <div class="title-block">
        <div class="title-block--header">
          {{ content.cheaper_than_a_taxi }}
        </div>
        <div
          class="title-block--body"
          v-html="content.per_hour_rent"
        />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'HeaderText',
  computed: {
    content() {
      return this.$t('pages.for_business');
    },
  },
};
</script>

<style lang="scss" scoped>
.title-block {
  display: inline-block;
  color: #fff;
  text-align: center;
  text-transform: uppercase;
  letter-spacing: 6px;

  &--body {
    background-color: #000;
    border-radius: 6px;
    padding: 8px 16px;
    font-size: 20px;

    @media (max-width: $breakpoint-xs-max) {
      letter-spacing: 2px;
    }

    ::v-deep span {
      color: $primary;
    }
  }

  &--header {
    position: relative;
    padding: 8px 48px;
    z-index: 0;
    font-size: 14px;

    &::after,
    &::before {
      content: '';
      position: absolute;
      top: 0;
      bottom: 0;
      background-color: #645336;
      border-radius: 6px 6px 0 0;
      z-index: -1;
    }

    &::after {
      right: 25%;
      left: 32px;
      transform: skew(-25deg, 0);
    }

    &::before {
      right: 32px;
      left: 25%;
      transform: skew(25deg, 0);
    }
  }
}
</style>
